<template>
  <div class="flex-1 overflow-auto p-4">
    <!-- List Canned Response -->
    <div class="flex flex-row gap-4">
      <div class="w-[60%]">
        <p
          v-if="!inboxesList.length"
          class="flex h-full items-center flex-col justify-center"
        >
          {{ $t('INBOX_MGMT.LIST.404') }}
          <router-link
            v-if="hasCreatePermission('Inbox')"
            :to="addAccountScoping('settings/inboxes/new')"
          >
            {{ $t('SETTINGS.INBOXES.NEW_INBOX') }}
          </router-link>
        </p>

        <table v-if="inboxesList.length" class="woot-table">
          <tbody>
            <tr v-for="(item, idx) in inboxesList" :key="item.id">
              <td>
                <img
                  v-if="item.avatar_url"
                  class="woot-thumbnail"
                  :src="item.avatar_url"
                  alt="No Page Image"
                />
                <img
                  v-else
                  class="woot-thumbnail"
                  src="~dashboard/assets/images/flag.svg"
                  alt="No Page Image"
                />
              </td>
              <!-- Short Code  -->
              <td>
                <span class="tex-red" v-if="item.channel_type === 'Channel::TiktokProfile' && tokenIsExpired(item.token_expires)">
                  {{ $t('SETTINGS.INBOXES.EXPIRED') }}
                </span>
                <span class="agent-name">
                  {{ item.channel_type === 'Channel::Sms' && item.phone_number
                  ? `${item.name.replace(/\s*\([^)]*\)$/, '')} (0${item.phone_number.slice(3)})`: item.name }}
                </span>
                <span v-if="item.channel_type === 'Channel::FacebookPage'">
                  Facebook
                </span>
                <span v-if="item.channel_type === 'Channel::FacebookPage2'">
                  Facebook Post
                </span>
                <span v-if="item.channel_type === 'Channel::WebWidget'">
                  Website
                </span>
                <span v-if="item.channel_type === 'Channel::TwitterProfile'">
                  Twitter
                </span>
                <span v-if="item.channel_type === 'Channel::TwilioSms'">
                  {{ twilioChannelName(item) }}
                </span>
                <span v-if="item.channel_type === 'Channel::Whatsapp'">
                  Whatsapp
                </span>
                <span v-if="item.channel_type === 'Channel::Sms'">
                  SMS
                </span>
                <span v-if="item.channel_type === 'Channel::Whatsapp'">
                  Whatsapp
                </span>
                <span v-if="item.channel_type === 'Channel::Email'">
                  Email
                </span>
                <span v-if="item.channel_type === 'Channel::Telegram'">
                  Telegram
                </span>
                <span v-if="item.channel_type === 'Channel::TiktokProfile'">
                  TikTok
                </span>
                <span v-if="item.channel_type === 'Channel::Line'">Line</span>
                <span v-if="item.channel_type === 'Channel::Api'">
                  {{item.api_type && item.api_type.charAt('w') ? ` Whatsapp V${item.api_type.slice(-1)}` : globalConfig.apiChannelName || 'API'}}
                </span>
                <!-- QM §3.1 — which queue this inbox drops new conversations into, so the
                     routing owner can read it off the list instead of opening each inbox. -->
                <span
                  v-if="defaultQueueName(item)"
                  v-tooltip.top="$t('QUEUES_MGMT.INBOX.DEFAULT_QUEUE_LABEL')"
                  class="ml-2 rtl:mr-2 rtl:ml-0 text-slate-600 dark:text-slate-400"
                >
                  {{ defaultQueueName(item) }}
                </span>
              </td>

              <!-- Action Buttons -->
              <td>
                <div class="button-wrapper">
                  <router-link
                    :to="addAccountScoping(`settings/inboxes/${item.id}`)"
                  >
                    <woot-button
                      v-if="hasEditPermission('Inbox')"
                      v-tooltip.top="$t('INBOX_MGMT.SETTINGS')"
                      variant="smooth"
                      size="tiny"
                      icon="settings"
                      color-scheme="secondary"
                      class-names="grey-btn"
                    />
                  </router-link>

                  <woot-button
                    v-if="hasDeletePermission('Inbox') && !isWa(item)"
                    v-tooltip.top="$t('INBOX_MGMT.DELETE.BUTTON_TEXT')"
                    variant="smooth"
                    color-scheme="alert"
                    size="tiny"
                    class-names="grey-btn"
                    :is-loading="loading[item.id]"
                    icon="dismiss-circle"
                    @click="openDelete(rawInboxesList[idx])"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="w-[34%]">
        <span
          v-dompurify-html="
            useInstallationName(
              $t('INBOX_MGMT.SIDEBAR_TXT'),
              globalConfig.installationName
            )
          "
        />
      </div>
    </div>
    <settings
      v-if="showSettings"
      :show.sync="showSettings"
      :on-close="closeSettings"
      :inbox="selectedInbox"
    />

    <woot-confirm-delete-modal
      v-if="showDeletePopup"
      :show.sync="showDeletePopup"
      :title="$t('INBOX_MGMT.DELETE.CONFIRM.TITLE')"
      :message="confirmDeleteMessage"
      :confirm-text="deleteConfirmText"
      :reject-text="deleteRejectText"
      :confirm-value="selectedInbox.name"
      :confirm-place-holder-text="confirmPlaceHolderText"
      @on-confirm="confirmDeletion"
      @on-close="closeDelete"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Settings from './Settings.vue';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import accountMixin from '../../../../mixins/account';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import { INBOX_TYPES } from 'shared/mixins/inboxMixin';
// QM §3.1 — reused purely for its `isQueueManagementEnabled` computed.
import queueSupervisionMixin from 'dashboard/mixins/queueSupervision';

export default {
  components: {
    Settings,
  },
  mixins: [
    hasPermissionMixin,
    accountMixin,
    globalConfigMixin,
    queueSupervisionMixin,
  ],
  data() {
    return {
      loading: {},
      showSettings: false,
      showDeletePopup: false,
      selectedInbox: {},
    };
  },
  computed: {
    ...mapGetters({
      inboxesList: 'inboxes/getInboxes',
      rawInboxesList: 'inboxes/getRawInboxes',
      globalConfig: 'globalConfig/get',
      queue: 'queues/getQueue',
    }),
    // Delete Modal
    deleteConfirmText() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.YES')}`;
    },
    deleteRejectText() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.NO')}`;
    },
    confirmDeleteMessage() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.MESSAGE', {
        inboxName: this.selectedInbox.name,
      })}`;
    },
    confirmPlaceHolderText() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.PLACE_HOLDER', {
        inboxName: this.selectedInbox.name,
      })}`;
    },
  },
  mounted() {
    // QM §3.1 — the inbox payload carries default_queue_id only; names live in the queues store.
    if (this.isQueueManagementEnabled) {
      this.$store.dispatch('queues/get');
    }
  },
  methods: {
    // QM §3.1 — blank while the feature is off, the inbox has no queue, or the store has not
    // caught up yet; the template hides the span in all three cases.
    defaultQueueName(inbox) {
      if (!this.isQueueManagementEnabled || !inbox.default_queue_id) return '';
      return this.queue(inbox.default_queue_id).name || '';
    },
    isWa(channel) {
      const api_type = channel.api_type && channel.api_type.charAt(0) === 'w';
      return (
        (channel.channelType || channel.channel_type) ===
          INBOX_TYPES.WHATSAPP || api_type
      );
    },
    tokenIsExpired(tokenDate) {
      const unixDateNow = Math.floor(Date.now() / 1000)
      return unixDateNow > tokenDate;
    },
    twilioChannelName(item) {
      const { medium = '' } = item;
      if (medium === 'whatsapp') return 'WhatsApp';
      return 'Twilio SMS';
    },
    openSettings(inbox) {
      this.showSettings = true;
      this.selectedInbox = inbox;
    },
    closeSettings() {
      this.showSettings = false;
      this.selectedInbox = {};
    },
    async deleteInbox({ id }) {
      try {
        const data = await this.$store.dispatch('inboxes/delete', id);
        bus.$emit(
          'newToastMessage',
          this.$t(data && data.status === 'in_process' ? 'INBOX_MGMT.DELETE.API.IN_PROCESS_MESSAGE' : 'INBOX_MGMT.DELETE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        bus.$emit(
          'newToastMessage',
          this.$t('INBOX_MGMT.DELETE.API.ERROR_MESSAGE')
        );
      }
    },

    confirmDeletion() {
      this.deleteInbox(this.selectedInbox);
      this.closeDelete();
    },
    openDelete(inbox) {
      this.showDeletePopup = true;
      this.selectedInbox = inbox;
    },
    closeDelete() {
      this.showDeletePopup = false;
      this.selectedInbox = {};
    },
  },
};
</script>

<style lang="scss">
.tex-red {
  color: red;
}
</style>
